import { ChangeEvent } from "react"

type EmailFormInputProps =  {
    id: string | undefined
    value?: string
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
    validationMessage: string | ""
    autoFocus: boolean
}

export default function EmailFormInput(props: EmailFormInputProps) {    
    const { id, value, onChange, validationMessage, autoFocus} = props

    return (
        <div className="text-left my-6">
            <input
                id={id}
                type="email"
                placeholder="Email"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300"
                autoFocus={autoFocus}
                value={value}
                onChange={onChange}
            />
            { validationMessage && <span className="text-red-600">{validationMessage}</span> }
        </div>
    )
}